<template>
    <div class="frame-annotation-card" :class="{ 'is-active': checked }" @click="handleClick">
        <div class="frame-annotation-card__content">
            <el-image class="frame-img" :src="imageUrl"> </el-image>
            <div class="frame-num">{{ data.id }}</div>
            <div class="opt-btn-group">
                <i class="el-icon-delete icon-delete" v-if="showDelete" @click.stop="handleDeleteClick"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        data: {
            type: Object,
            default() {
                return {};
            },
        },
        currentSource: {
            // 当前选中的资源
            type: Object,
            default() {
                return {};
            },
        },
        checked: {
            // 是否选中状态
            type: Boolean,
            default: false,
        },
        showDelete: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        imageUrl() {
            let src = '';
            let currentSource = this.currentSource || {};
            let images = currentSource.images || [];
            // console.log(this.data);
            for (let i = 0; i < images.length; i++) {
                let image = images[i];
                if (image.id === this.data.image_id) {
                    src = image.url;
                    break;
                }
            }
            return src;
        },
    },
    methods: {
        handleClick() {
            console.log(this.data);
            this.$emit('click');
        },
        handleDeleteClick() {
            this.$emit('delete');
        },
    },
    created() {},
    mounted() {},
    watch: {},
};
</script>

<style lang="scss" scoped>
.frame-annotation-card {
    /* display: inline-block; */
    height: inherit;
    // width: inherit;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    & + .frame-annotation-card {
        margin-left: 16px;
    }
    &__content {
        position: relative;
        .frame-img {
            height: 114px;
            // width: 120px;
            width: 100%;
            position: relative;
        }

        .frame-num {
            position: absolute;
            top: 0px;
            left: 0px;
            background: rgba(3, 5, 61, 0.5);
            color: #fff;
            padding: 4px 6px;
            font-size: 12px;
        }
        .opt-btn-group {
            position: absolute;
            top: 3px;
            right: 3px;
            background: rgba(3, 5, 61, 0.5);
            color: #fff;
            padding: 2px;
            .icon-delete {
                cursor: pointer;
            }
        }
    }
}
.is-active {
    .frame-img {
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border: 3px solid #2e7df8;
            transition: all 0.3s;
        }
    }
}
</style>
